import React, { useState } from "react";
import { createContext } from "react";

export const ToastContext = createContext();
export default function ToastProvider({ children }) {
  const [show, setShow] = useState(false);

  return (
    <ToastContext.Provider value={{ show, setShow }}>
      {children}
    </ToastContext.Provider>
  );
}
